package org.solyton.solawi.bid.module.user.`data`.organization

import kotlin.String
import kotlin.collections.List
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.user.`data`.member.Member

/**
 * Autogenerated ReadOnly Lens.
 * Read [Organization.organizationId]
 */
@ReadOnly
public val organizationId: Lens<Organization, String> by lazy {
      Lens(
        get = { whole -> whole.organizationId },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [Organization.name]
 */
@ReadWrite
public val name: Lens<Organization, String> by lazy {
      Lens(
        get = { whole -> whole.name },
        set = { part -> { whole -> whole.copy(name = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Organization.name]
 */
@ReadWrite
public fun Organization.name(`set`: String.() -> String): Organization = copy(name = set(name))

/**
 * Autogenerated ReadOnly Lens.
 * Read [Organization.contextId]
 */
@ReadOnly
public val contextId: Lens<Organization, String> by lazy {
      Lens(
        get = { whole -> whole.contextId },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [Organization.subOrganizations]
 */
@ReadWrite
public val subOrganizations: Lens<Organization, List<Organization>> by lazy {
      Lens(
        get = { whole -> whole.subOrganizations },
        set = { part -> { whole -> whole.copy(subOrganizations = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Organization.subOrganizations]
 */
@ReadWrite
public fun Organization.subOrganizations(`set`: List<Organization>.() -> List<Organization>):
    Organization = copy(subOrganizations = set(subOrganizations))

/**
 * Autogenerated Lens.
 * Read and manipulate [Organization.members]
 */
@ReadWrite
public val members: Lens<Organization, List<Member>> by lazy {
      Lens(
        get = { whole -> whole.members },
        set = { part -> { whole -> whole.copy(members = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Organization.members]
 */
@ReadWrite
public fun Organization.members(`set`: List<Member>.() -> List<Member>): Organization = copy(members
    = set(members))
